import { render } from "./AsCoursesContent.vue?vue&type=template&id=114fc7ea&ts=true"
import script from "./AsCoursesContent.vue?vue&type=script&lang=ts"
export * from "./AsCoursesContent.vue?vue&type=script&lang=ts"

import "./AsCoursesContent.vue?vue&type=style&index=0&id=114fc7ea&lang=scss"

import exportComponent from "/home/gitlab-runner/builds/q5ZtNtxNr/0/anyclass/platform-frontend/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__